import { MNSproCloudApi } from '../..';

import {
  ApiKeyCreateRequest,
  ApiKeyDeleteRequest,
  ApiKeyResponse,
} from '../../api/v2';

export class ApiKeysService {
  static async getAllApiKeys(
    authToken: string,
    organizationId: string,
  ): Promise<ApiKeyResponse[]> {
    const config = MNSproCloudApi.V2.createConfiguration(authToken);
    const api = MNSproCloudApi.V2.ApiKeysApiFactory(config);

    const result = await api.getAllApiKeys(organizationId);

    return result.data;
  }

  static async createApiKey(
    authToken: string,
    apiRequest: ApiKeyCreateRequest,
  ): Promise<ApiKeyResponse> {
    const config = MNSproCloudApi.V2.createConfiguration(authToken);
    const api = MNSproCloudApi.V2.ApiKeysApiFactory(config);

    const result = await api.createApiKey(apiRequest);
    return result.data;
  }

  static async deleteApiKey(
    authToken: string,
    apiRequest: ApiKeyDeleteRequest,
  ): Promise<void> {
    const config = MNSproCloudApi.V2.createConfiguration(authToken);
    const api = MNSproCloudApi.V2.ApiKeysApiFactory(config);

    const result = await api.deleteApiKey(apiRequest);
    return result.data;
  }
}
